<script setup lang="ts">
import {defineAsyncComponent, nextTick, onMounted, watch} from 'vue';
import { useRoute } from 'vue-router';
import { ref, computed } from 'vue';
import {useLenis} from "../composable/useLenis.ts";

// Get the route object
const route = useRoute();

// Define a mapping between slug and component
const componentsMap: Record<string, any> = {
  yonder: defineAsyncComponent(() => import('../views/caseStudiesPages/Yoder.vue')),
  runna: defineAsyncComponent(() => import('../views/caseStudiesPages/Runna.vue')),
  numan: defineAsyncComponent(() => import('../views/caseStudiesPages/Numan.vue')),
  frive: defineAsyncComponent(() => import('../views/caseStudiesPages/Frive.vue')),
  carmoola: defineAsyncComponent(() => import('../views/caseStudiesPages/Carmoola.vue')),
  ebuyer: defineAsyncComponent(() => import('../views/caseStudiesPages/EBuyer.vue')),
  hbme: defineAsyncComponent(() => import('../views/caseStudiesPages/H&B&me.vue')),
  fyxer: defineAsyncComponent(() => import('../views/caseStudiesPages/Fyxer.vue')),
  neat: defineAsyncComponent(() => import('../views/caseStudiesPages/Neat.vue')),
  katkin: defineAsyncComponent(() => import('../views/caseStudiesPages/Katkin.vue')),
  zoe: defineAsyncComponent(() => import('../views/caseStudiesPages/Zoe.vue')),
  sundayCitizen: defineAsyncComponent(() => import('../views/caseStudiesPages/SundayCitizen.vue')),
  sipGood: defineAsyncComponent(() => import('../views/caseStudiesPages/SipGood.vue')),
  life360: defineAsyncComponent(() => import('../views/caseStudiesPages/Life360.vue')),
  wild: defineAsyncComponent(() => import('../views/caseStudiesPages/Wild.vue')),
  skinMe: defineAsyncComponent(() => import('../views/caseStudiesPages/SkinMe.vue')),
  riseFall: defineAsyncComponent(() => import('../views/caseStudiesPages/RiseFall.vue')),
  heights: defineAsyncComponent(() => import('../views/caseStudiesPages/Heights.vue')),
};
const lenis = useLenis()

// Compute the component based on the slug
const currentComponent = computed(() => {
  const slug = route.params.slug as string;
  return componentsMap[slug] || null;
});

// Scroll function with extra delay after DOM update
const scrollToTop = async () => {
  await nextTick();
  // Give time for async component to render
  setTimeout(() => {
    lenis.value?.scrollTo(0)
  }, 50)
};

// First load
onMounted(() => {
  scrollToTop();
});

// On slug change
watch(() => route.params.slug, () => {
  scrollToTop();
});
</script>

<template>
  <div>
    <component :is="currentComponent" v-if="currentComponent" :key="route.params.slug" />
    <div v-else>
      <p class="text-center text-red-500 mt-10">Case study not found.</p>
    </div>
  </div>
</template>
